import { Directive, HostBinding } from '@angular/core';

/** Adds `phx-sheet-drag-area` on the same element as `phx-bottom-sheet-body` for drag behavior on body. */
@Directive({
  selector: '[phx-bottom-sheet-body]',
})
export class PhxBottomSheetBodyDirective {
  @HostBinding('attr.phx-sheet-drag-area')
  readonly phxSheetDragAreaAttr = '';
}
